import ClickOutside from "vue-click-outside";
import {mapState} from 'vuex';
export default{

    computed: {
      ...mapState('tournaments', ['tournament'])
    },
    // props: ['tournament'],
    directives: {
        ClickOutside
    },
    props: ['show'],
    watch: {
      show: function(newVal){
          this.filterShow = newVal
      }
    },
    data(){
        return{
            filterShow: this.show,
            closeCheck: false
        }
    },
    methods: {
        afterEnter() {
            this.closeCheck = true
        },
        afterLeave() {
            this.closeCheck = false
            this.$emit('close');
        },

        selectReset() {
            this.searchType = 0
            this.searchState = 0
            this.selectDate = 'all'
        },
        filterSetting(){

        },
        handleFocusOut(){
            if(this.closeCheck){
                this.filterShow = false
            }
        }
    },
}
